/**
 * @class MediaModel
 * @classdesc Handles creating an model media element
 *
 * @extends Core.Component
 */
export default class MediaModel extends Core.Component {
  constructor(el, context) {
    super(el, context);

    const modelEl = this.el.querySelector('model-viewer');

    this._model = Core.Media.createModel(modelEl);
  }

  /**
   * Play the model and dispatch video-related events based on resolve/reject from Promise
   * @public
   */
  play() {
    this._model.play();
  }

  /**
   * Pause the video
   * @public
   */
  pause() {
    this._model.pause();
  }

  /**
   * Unload the video on unmount
   */
  onDismount() {
    this._model.unload();
  }
}
